import { useSelector } from 'react-redux';

import HotelLogo from '../components/common/HotelLogo';
import SectionHeader from '../components/common/SectionHeader';
import Text from '../components/common/Text';

// Social media icons
import facebookIcon from '../assets/svg/facebook-icon.svg';
import instagramIcon from '../assets/svg/instagram-icon.svg';
import xIcon from '../assets/svg/x-icon.svg';
import websiteIcon from '../assets/svg/website-icon.svg';

const DEFAULT_THANK_YOU_TEXT = `We hope to see you back soon. 
At YoursTruly, we constantly thrive to make every hospitality guest happy. If you have any further feedback or questions, please feel free to write us an email: hello@yourstruly.de`;

const ThankYouPage = () => {
  const {
    name,
    thankYouText,
    facebookLink,
    instagramLink,
    twitterLink,
    websiteLink,
  } = useSelector((state) => state.app.hotelInformation);
  const hasSocialLink = facebookLink || instagramLink || twitterLink || websiteLink;

  return (
    <main className="flex min-h-screen flex-col gap-16 py-16">
      <HotelLogo />
      <section className="flex flex-col gap-8">
        <SectionHeader text="Thank you." />
        <Text>{thankYouText || DEFAULT_THANK_YOU_TEXT}</Text>
        <div className="mt-6">
          <Text>Sincerely,</Text>
          <Text>{`Your ${name} Team`}</Text>
        </div>
        <HotelLogo left />

        <div className="mt-10 flex flex-col gap-3">
          {hasSocialLink ? <Text>Follow us on Social:</Text> : null}
          <div className="mt-3 flex gap-2">
            {facebookLink?.length ? (
              <a href={facebookLink}>
                <img className="h-10" src={facebookIcon} alt="Facebook icon" />
              </a>
            ) : null}
            {instagramLink?.length ? (
              <a href={instagramLink}>
                <img
                  className="h-10"
                  src={instagramIcon}
                  alt="Instagram icon"
                />
              </a>
            ) : null}
            {twitterLink?.length ? (
              <a href={twitterLink}>
                <img className="h-10" src={xIcon} alt="X icon" />
              </a>
            ) : null}
            {websiteLink?.length ? (
              <a href={websiteLink}>
                <img className="h-10" src={websiteIcon} alt="Website icon" />
              </a>
            ) : null}
          </div>
        </div>
      </section>
    </main>
  );
};

export default ThankYouPage;
